import { Colors } from '../Variables.style';
import { rgba, darken, lighten } from '../Mixins.style';

const theme = {
  loadingScreen: {
    background: Colors.apple,
    color: Colors.white,
  },
  loadingData: {
    color: Colors.tundora,
  },
  noResults: {
    color: Colors.tundora,
  },
  sign: {
    wrapper: {
      default: {
        background: Colors.white,
      },
      alternative: {
        background: Colors.alto,
      },
    },
    footer: {
      default: {
        color: Colors.tundora,
        colorOnHover: Colors.apple,
      },
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
    check: {
      default: {
        color: Colors.tundora,
        background: Colors.white,
        borderColor: Colors.silver,
        borderColorOnInvalid: Colors.cranberry,
        borderColorOnValid: Colors.apple,
        iconColor: Colors.apple,
      },
    },
    linkbox: {
      color: Colors.tundora,
      colorOnHover: Colors.apple,
    },
  },
  button: {
    default: {
      color: Colors.white,
      colorOnHover: Colors.white,
      background: Colors.apple,
      backgroundOnHover: darken(Colors.apple, 15),
      border: Colors.transparent,
      borderOnHover: Colors.transparent,
      shadow: rgba(Colors.chatelle, 1),
    },
    alt: {
      color: Colors.apple,
      colorOnHover: lighten(Colors.apple, 15),
      background: Colors.seashell,
      backgroundOnHover: lighten(Colors.seashell, 15),
      border: Colors.transparent,
      borderOnHover: Colors.transparent,
      shadow: rgba(Colors.chatelle, 1),
    },
    normal: {
      color: Colors.tundora,
      colorOnHover: darken(Colors.tundora, 15),
      background: Colors.white,
      backgroundOnHover: Colors.white,
      border: Colors.silver,
      borderOnHover: Colors.silver,
      shadow: rgba(Colors.black, 0.03),
    },
    primary: {
      color: Colors.white,
      colorOnHover: darken(Colors.white, 15),
      background: Colors.apple,
      backgroundOnHover: Colors.apple,
      border: Colors.silver,
      borderOnHover: Colors.silver,
      shadow: rgba(Colors.black, 0.03),
    },
    danger: {
      color: Colors.thunderbird,
      colorOnHover: darken(Colors.thunderbird, 15),
      background: Colors.white,
      backgroundOnHover: Colors.white,
      border: Colors.silver,
      borderOnHover: Colors.silver,
      shadow: rgba(Colors.black, 0.03),
    },
    transparent: {
      color: Colors.apple,
      colorOnHover: darken(Colors.apple, 15),
      background: Colors.transparent,
      backgroundOnHover: Colors.transparent,
      border: Colors.transparent,
      borderOnHover: Colors.transparent,
      shadow: Colors.transparent,
    },
  },
  more: {
    color: Colors.tundora,
    colorOnHover: Colors.apple,
  },
  content: {
    panel: {
      default: {
        background: Colors.whiteTwo,
        thumb: Colors.apple,
        track: Colors.wildSand,
      },
    },
    information: {
      default: {
        color: Colors.tundora,
      },
    },
    card: {
      default: {
        border: Colors.whisper,
        background: Colors.white,
        shadow: rgba(Colors.bonJour, 0.68),
        borderColor: Colors.apple,
      },
    },
  },
  sider: {
    wrapper: {
      background: Colors.whiteTwo,
      backgroundLine: Colors.whisper,
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    logobox: {
      background: Colors.whiteTwo,
    },
    item: {
      color: Colors.silverChaliceThree,
      colorOnHover: Colors.silverChaliceThree,
      colorOnActive: Colors.apple,
      colorOnDisabled: Colors.silverChaliceThree,
      backgroundLine: Colors.transparent,
      backgroundLineOnHover: Colors.transparent,
      backgroundLineOnActive: Colors.apple,
      backgroundLineOnDisabled: Colors.transparent,
    },
    toggler: { color: Colors.silverChaliceThree, colorOnHover: Colors.apple },
  },
  header: {
    wrapper: {
      background: Colors.whiteTwo,
      backgroundLine: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
  },
  headerLabel: {
    label: {
      color: Colors.dustyGray,
    },
  },
  profile: {
    name: {
      color: Colors.dustyGray,
      colorOnHover: Colors.apple,
    },
    avatarHolder: {
      border: Colors.apple,
    },
    avatar: {
      background: Colors.apple,
    },
    content: {
      background: Colors.white,
      border: Colors.chatelle,
      shadow: rgba(Colors.black, 0.16),
    },
    item: {
      color: Colors.tundora,
      colorOnHover: Colors.apple,
      background: Colors.transparent,
      backgroundOnHover: Colors.transparent,
      backgroundLine: Colors.whisper,
    },
  },
  modal: {
    holder: {
      background: rgba(Colors.black, 0.3),
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    panel: {
      background: Colors.whiteTwo,
      shadow: rgba(Colors.black, 0.16),
    },
    close: {
      color: Colors.chatelle,
      colorOnHover: Colors.tundora,
    },
  },
  dataSourceAdd: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
    row: {
      border: Colors.whisper,
    },
    subtitle: {
      color: Colors.tundora,
    },
    typeTitle: {
      color: Colors.apple,
    },
    info: {
      color: Colors.silver,
    },
    tag: {
      color: Colors.tundora,
      background: Colors.seashell,
      colorOnSelected: Colors.white,
      backgroundOnSelected: Colors.apple,
    },
  },
  dataSourceDelete: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
      deco: {
        color: Colors.apple,
      },
    },
  },
  input: {
    default: {
      color: Colors.tundora,
      colorPlaceholder: Colors.silver,
      colorOnInvalid: Colors.cranberry,
      background: Colors.white,
      borderColor: Colors.silver,
      borderColorOnInvalid: Colors.cranberry,
      borderColorOnValid: Colors.apple,
    },
  },
  select: {
    control: {
      background: Colors.white,
      borderColor: Colors.silver,
      borderColorOnInvalid: Colors.cranberry,
      borderColorOnValid: Colors.apple,
    },
    placeholder: {
      color: Colors.silver,
    },
    singleValue: {
      color: Colors.tundora,
      colorOnInvalid: Colors.cranberry,
    },
    input: {
      color: Colors.tundora,
      colorOnInvalid: Colors.cranberry,
    },
    noOptionsMessage: {
      color: Colors.tundora,
    },
    menuList: {
      background: Colors.white,
      borderColor: Colors.silver,
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    option: {
      color: Colors.tundora,
      backgroundOnHover: Colors.whiteTwo,
      backgroundOnSelect: Colors.whiteTwo,
    },
    indicatorIcon: {
      color: Colors.silver,
      colorOnHover: Colors.tundora,
    },
    checkbox: {
      input: {
        background: Colors.transparent,
        border: Colors.mineShaft,
        backgroundOnCheckmark: Colors.apple,
        borderOnCheckmark: Colors.apple,
      },
      checkmark: {
        colorOnCheckmark: Colors.white,
      },
    },
    radio: {
      input: {
        background: Colors.transparent,
        border: Colors.mineShaft,
        backgroundOnCheckmark: Colors.apple,
        borderOnCheckmark: Colors.apple,
      },
      checkmark: {
        colorOnCheckmark: Colors.white,
      },
    },
  },
  inputError: {
    default: {
      color: Colors.cranberry,
    },
  },
  dataSource: {
    header: {
      backgroundLine: Colors.whisper,
    },
    title: {
      color: Colors.tundora,
    },
    text: {
      color: Colors.tundora,
    },
    footer: {
      backgroundLine: Colors.whisper,
    },
    label: {
      color: Colors.mineshaft,
      background: Colors.seashell,
    },
  },
  link: {
    color: Colors.apple,
  },
  viewerPage: {
    selectionHolder: {
      color: Colors.apple,
    },
    selection: {
      background: Colors.white,
      border: Colors.apple,
      backgroundOnCheckmark: Colors.apple,
      borderOnCheckmark: Colors.apple,
    },
    selectionCheckmark: {
      colorOnCheckmark: Colors.white,
    },
  },
  photoDocument: {
    imageHolder: {
      background: Colors.bonJour,
    },
    detail: {
      color: Colors.mineshaft,
    },
    detailLabel: {
      color: Colors.boulder,
    },
    label: {
      color: Colors.white,
      background: Colors.apple,
      shadow: rgba(Colors.black, 0.02),
    },

    selection: {
      background: Colors.white,
      border: Colors.apple,
      backgroundOnCheckmark: Colors.apple,
      borderOnCheckmark: Colors.apple,
      borderOnHoverUnselected: Colors.silver,
      borderOnHoverSelected: Colors.white,
    },
    selectionCheckmark: {
      colorOnCheckmark: Colors.white,
    },
    image: {
      border: Colors.apple,
    },
    video: {
      border: Colors.apple,
    },
    videoIcon: {
      color: Colors.white,
    },
    icon: {
      color: Colors.white,
      colorHover: Colors.apple,
    },
  },
  photoDocumentDetails: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    imageHolder: {
      background: Colors.bonJour,
    },
    arrow: {
      color: Colors.white,
      shadow: Colors.tundora,
    },
    contentHolder: { thumb: Colors.apple, track: Colors.wildSand },
    header: {
      border: Colors.whisper,
      background: Colors.white,
    },
    title: {
      color: Colors.tundora,
    },
    subtitle: {
      color: Colors.tundora,
    },
    detail: {
      background: Colors.seashell,
      color: Colors.mineshaft,
    },
    detailLabel: {
      color: Colors.boulder,
    },
    footer: {
      backgroundLine: Colors.whisper,
    },
  },
  annotation: {
    holder: { thumb: Colors.apple, track: Colors.wildSand },
    panel: {
      background: Colors.white,
      border: Colors.whisper,
    },
    imageHolder: {
      background: Colors.bonJour,
    },
    arrow: {
      color: Colors.white,
      shadow: Colors.tundora,
    },
    contentHolder: { thumb: Colors.apple, track: Colors.wildSand },
    header: {
      border: Colors.whisper,
      background: Colors.white,
    },
    title: {
      color: Colors.tundora,
    },
    detail: {
      background: Colors.seashell,
      color: Colors.mineshaft,
    },
    detailLabel: {
      color: Colors.boulder,
    },
    categoryTitle: {
      color: Colors.silverChalice,
    },
    categoryValue: {
      color: Colors.tundora,
      background: Colors.seashell,
      colorOnSelected: Colors.white,
      backgroundOnSelected: Colors.apple,
    },
  },
  aiTraining: {
    panel: {
      border: Colors.whisper,
      background: Colors.white,
      shadow: rgba(Colors.bonJour, 0.68),
    },
    title: {
      color: Colors.black,
    },
    category: {
      color: Colors.tundora,
    },
    deco: {
      color: Colors.apple,
    },
    row: {
      default: {
        background: Colors.white,
        border: Colors.silverTwo,
        shadow: rgba(Colors.black, 0.1),
      },
      head: {
        background: Colors.transparent,
        border: Colors.transparent,
        shadow: Colors.transparent,
      },
    },
    cell: {
      default: {
        color: Colors.mineshaft,
      },
      head: {
        color: Colors.gray,
      },
    },
  },
  alTrainingAdd: {
    wizardStepsCounter: { color: Colors.chatelle },
  },
  filter: {
    wrapper: {
      background: Colors.white,
      border: Colors.silverChaliceTwo,
    },
    holder: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    content: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    toggleBox: {
      background: Colors.white,
      border: Colors.chatelle,
      backgroundOnActive: Colors.apple,
      shadow: rgba(Colors.chatelle, 0.43),
    },
    toggle: {
      background: Colors.transparent,
      color: Colors.scorpionTwo,
      colorOnActive: Colors.white,
    },
    info: {
      color: Colors.silver,
    },
    resetFilterButton: {
      color: Colors.silver,
      colorOnHover: Colors.tundora,
    },
    selectionHolder: {
      color: Colors.apple,
    },
    selection: {
      background: Colors.white,
      border: Colors.apple,
      backgroundOnCheckmark: Colors.apple,
      borderOnCheckmark: Colors.apple,
    },
    selectionCheckmark: {
      colorOnCheckmark: Colors.white,
    },
  },
  dropdown: {
    dropdownButton: {
      color: Colors.white,
      colorOnHover: darken(Colors.white, 15),
      colorOnToggle: Colors.apple,
      background: Colors.apple,
      backgroundOnHover: Colors.apple,
      backgroundOnToggle: Colors.white,
      border: Colors.whisper,
      borderOnHover: Colors.whisper,
      borderOnToggle: Colors.whisper,
      shadow: rgba(Colors.black, 0.03),
    },
    dropdownContent: {
      background: Colors.white,
      border: Colors.whisper,
    },
    dropdownOption: {
      color: Colors.tundora,
      colorOnHover: Colors.apple,
      background: Colors.transparent,
      backgroundOnHover: Colors.transparent,
      backgroundLine: Colors.whisper,
    },
  },
  apiDescription: {
    item: {
      backgroundLine: Colors.whisper,
    },
    title: {
      color: Colors.tundora,
    },
    param: {
      color: Colors.scorpionTwo,
    },
    details: {
      color: Colors.scorpionTwo,
    },
    attributesTitle: { color: Colors.tundora },
    attributesContent: {
      color: Colors.doveGray,
      background: rgba(Colors.seashell, 0.27),
      border: Colors.altoTwo,
    },
    bodyTitle: { color: Colors.tundora },
    bodyContent: {
      color: Colors.doveGray,
      background: rgba(Colors.seashell, 0.27),
      border: Colors.altoTwo,
    },
    responseTitle: {
      color: Colors.alabaster,
      background: Colors.mineShaftTwo,
      border: Colors.silver,
    },
    responseContent: {
      color: Colors.alabaster,
      background: Colors.mineshaft,
      border: Colors.silver,
    },
  },
  apiDescriptionTabs: {
    box: {
      background: Colors.white,
      border: Colors.chatelle,
      shadow: rgba(Colors.chatelle, 0.43),
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    item: {
      background: Colors.transparent,
      color: Colors.scorpionTwo,
      colorOnSelected: Colors.apple,
      backgroundLine: Colors.whisper,
    },
  },
  profileManage: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    subtitle: {
      color: Colors.tundora,
    },
  },
  profileManageAsideTabs: {
    box: {
      background: Colors.white,
      border: Colors.chatelle,
      shadow: rgba(Colors.chatelle, 0.43),
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    item: {
      background: Colors.transparent,
      color: Colors.scorpionTwo,
      colorOnSelected: Colors.apple,
      backgroundLine: Colors.whisper,
    },
  },
  profileManageBasic: {
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
    subtitle: {
      color: Colors.tundora,
    },
  },
  profileManageUsers: {
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    subtitle: {
      color: Colors.tundora,
    },
    row: {
      default: {
        background: Colors.white,
        border: Colors.silverTwo,
        shadow: rgba(Colors.black, 0.1),
      },
      head: {
        background: Colors.transparent,
        border: Colors.transparent,
        shadow: Colors.transparent,
      },
    },
    cell: {
      default: {
        color: Colors.mineshaft,
      },
      head: {
        color: Colors.gray,
        colorOnActive: Colors.apple,
      },
    },
    avatarHolder: {
      border: Colors.apple,
    },
    avatar: {
      background: Colors.apple,
    },
    deco: {
      color: Colors.apple,
    },
    sortSign: {
      color: Colors.gray,
      colorOnActive: Colors.apple,
    },
  },
  profileManageBilling: {
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    groupTitle: {
      color: Colors.tundora,
    },
    subtitle: {
      color: Colors.tundora,
    },
    group: {
      background: Colors.white,
      border: Colors.silverTwo,
      shadow: rgba(Colors.black, 0.1),
    },
    groupToggle: {
      background: Colors.white,
      border: Colors.chatelle,
      shadow: rgba(Colors.chatelle, 0.43),
      color: Colors.tundora,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
    info: {
      color: Colors.silver,
    },
    row: {
      default: {
        background: Colors.white,
        border: Colors.silverTwo,
        shadow: rgba(Colors.black, 0.1),
      },
      head: {
        background: Colors.transparent,
        border: Colors.transparent,
        shadow: Colors.transparent,
      },
    },
    cell: {
      default: {
        color: Colors.mineshaft,
      },
      head: {
        color: Colors.gray,
      },
    },
  },
  profilePhotoChanger: {
    photoHolder: {
      border: Colors.apple,
    },
    photo: {
      background: Colors.apple,
    },
  },
  photoCrop: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
  },
  profileManageUsersInviteUsers: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
      deco: {
        color: Colors.apple,
      },
    },
  },
  profileManageUsersManageUser: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
      deco: {
        color: Colors.apple,
      },
    },
  },
  dayPicker: {
    inputbox: {
      color: Colors.tundora,
      colorPlaceholder: Colors.silver,
      colorOnInvalid: Colors.cranberry,
      background: Colors.white,
      borderColor: Colors.silver,
      borderColorOnInvalid: Colors.cranberry,
      borderColorOnValid: Colors.apple,

      popperTriangleBorder: Colors.mercury,
      popperHeaderBorder: Colors.silver,
      popperHeaderBg: Colors.apple,
      popperHeaderColor: Colors.white,
      popperColor: Colors.mineShaft,
      popperSelectedBg: Colors.apple,
      popperSelectedColor: Colors.white,
      popperDisabledBg: Colors.transparent,
      popperDisabledColor: Colors.silver,
      popperBorder: Colors.silver,
      popperShadow: rgba(Colors.black, 0.16),
    },
    inputIcon: {
      color: Colors.silver,
      colorOnHover: Colors.tundora,
    },
  },
  dashboardPanel: {
    panel: {
      border: Colors.whisper,
      background: Colors.white,
      shadow: rgba(Colors.bonJour, 0.68),
    },
    title: {
      color: Colors.tundora,
    },
    titleDeco: {
      color: Colors.apple,
    },
    subPanel: {
      border: Colors.whisper,
      background: Colors.white,
      shadow: rgba(Colors.bonJour, 0.68),
    },
    subPanelTitle: {
      color: Colors.tundora,
    },
    subPanelValue: {
      color: Colors.apple,
    },
    subPanelInfoLabel: {
      color: Colors.tundora,
    },
    subPanelInfoValue: {
      color: Colors.apple,
    },
    information: {
      color: Colors.gray,
    },
    tableRow: {
      default: {
        background: Colors.white,
        border: Colors.silverTwo,
        shadow: rgba(Colors.black, 0.1),
      },
      head: {
        background: Colors.transparent,
        border: Colors.transparent,
        shadow: Colors.transparent,
      },
    },
    tableCell: {
      default: {
        color: Colors.mineshaft,
      },
      head: {
        color: Colors.gray,
      },
    },
  },
  annotationCanvas: {
    canvasOptions: {
      area: {
        strokeStyle: Colors.black,
      },
      object: {
        strokeStyle: Colors.white,
        resizeCircle: {
          strokeStyle: Colors.thunderbird,
          fillStyle: Colors.supernova,
        },
        annotated: {
          strokeStyle: Colors.apple,
        },
        selected: {
          strokeStyle: Colors.supernova,
        },
      },
    },
  },
  annotationCanvasLegend: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    key: {
      color: Colors.white,
      background: Colors.mineshaft,
    },
  },
  photoDocumentRelabel: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
  },
  photoDocumentReject: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
  },
  photoDocumentDelete: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
  },
  photoDocumentsRelabel: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
  },
  photoDocumentsReject: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
  },
  photoDocumentsDelete: {
    wrapper: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
    header: {
      border: Colors.whisper,
    },
    title: {
      color: Colors.apple,
    },
    text: {
      default: {
        color: Colors.tundora,
      },
      error: {
        color: Colors.cranberry,
      },
    },
  },
  annotationSequence: {
    box: {
      thumb: Colors.apple,
      track: Colors.wildSand,
    },
  },
  annotationSequenceItem: {
    item: {
      border: Colors.transparent,
      borderOnSelected: Colors.apple,
    },
    imageHolder: {
      background: Colors.bonJour,
    },
    image: {
      border: Colors.apple,
    },
    video: {
      border: Colors.apple,
    },
    videoIcon: {
      color: Colors.white,
    },
    icon: {
      color: Colors.white,
      colorHover: Colors.apple,
    },
  },
};

export default theme;
